export default {
  slideMultiWrapperList: {
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden'
  },
  slideMultiWrapperTrack: {
    overflow: 'unset',
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    backfaceVisibility: 'hidden',
    willChange: 'transform, transition',
  },
  slideMultiWrapperTrackAnimated: {
    transition: 'transform 0.5s ease 0s',
  },
  slideItemWrapper: {
    width: '100%',
    overflow: 'hidden',
  },
};
